import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { authKeys, RequestTypes } from '@core/react-query/features/auth'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export type RevokeMFASessionResponse = {}

export const useRevokeMFASession = (
  options?: UseMutationOptions<
    RevokeMFASessionResponse,
    RequestErrorType,
    RequestTypes['revokeMFASession']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...authKeys.revokeMFASession,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: authKeys.getActiveMFASessions._def,
      })
    },
    ...options,
  })
}
